<template>
    <div class="elle-toggle-list">
        <div v-for="item in items" :key="item.id" class="item" @click.prevent="e => onToggle(e)">
            <div class="item-headline h4">
                <span class="text">{{ item.title }}</span>
            </div>
            <div class="item-content">
                <div class="content typography" v-html="item?.body" />

                <div v-if="item?.linkUrl.length && !item.linkUrl[0]?.isEmpty" class="buttons">
                    <UiLink :link="item?.linkUrl[0]" :style="'transparent w-border'" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        items?: CmsItem[];
    }>(),
    {
        items: () => []
    }
);

const items = computed(() => props.items);

const { $gsap: gsap, $ScrollTrigger: ScrollTrigger } = useNuxtApp();
const onToggle = (e: MouseEvent) => {
    const target = e.target as HTMLElement | null;
    if (!target) return;

    const parentItem = target.closest('.item') as HTMLElement | null;
    if (!parentItem) return;

    const itemContent = parentItem.querySelector('.item-content') as HTMLElement | null;
    if (!itemContent) return;

    const isActive = parentItem.classList.contains('active');

    gsap.to(itemContent, {
        height: isActive ? 0 : 'auto',
        marginTop: isActive ? '0' : '1.25rem',
        ease: isActive ? 'sine.out' : 'sine.in',
        onStart: () => {
            parentItem.classList.toggle('active', !isActive);
        },
        onComplete: () => {
            ScrollTrigger.refresh(true);
        }
    });
};
</script>
